var body = $('body');
var hamBtn = $('.js-hamBtn');


var mainSwiper = new Swiper(".main-swiper", {
    loop: true,
    speed: 400,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});


$(window).scroll(function() {
    var currentPos = $(this).scrollTop();
    if (currentPos > 150) {
        $(".js-pagetop-btn").addClass("show");
    } else {
        $(".js-pagetop-btn").removeClass("show");
    }
    startPos = currentPos;
});

$('.js-modal__hide').on('click', function() {
    $('.c-search__modal').addClass('_hide');
    $('body').addClass('overflow-unset');
});

var acc = document.getElementsByClassName("c-accordion");
var i;

for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });
}

$('.product__media-zoom').click(function() {
    $('.product__media-wrapper').toggleClass('image-zoom');
});

var swiper = new Swiper(".product-swiper", {
    slidesPerView: 2,
    spaceBetween: 20,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        768: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        1024: {
            slidesPerView: 6,
            spaceBetween: 20,
        },
    },
});


// $('.category_check').click(function() {
//     if (this.checked) {
//         $(this).addClass('check_active');
//     } else {
//         $(this).removeClass('check_active');
//     }
//     if ($('.check_active').length == 0) {
//         $('.search_product_item').css('display', 'block');
//     } else {
//         $('.search_product_item').css('display', 'none');
//         let selected = $('.check_active')
//         selected.map((item) => {
//             console.log(item)
//             $(`li[data-catecory='${$(selected[item]).attr("item")}']`).css('display', "block");
//         })

//     }
// })

$('.product-form__submit').click(function() {
    var cart_counter = parseInt($('.c-cart__counter').html());
    var quantity_number = parseInt($('.quantity__input').val());
    console.log(quantity_number);
    $('.c-cart__counter').html(cart_counter + quantity_number);
})

$(document).ready(function() {
    if ($(window).width() < 768) {
        var product_add_cart = $('.product__add-cart-pc').html();
        $('.product__add-cart-sp').html(product_add_cart);
        $('.product__add-cart-pc').remove();
    }
})


$(function() {
    var tag_value = null;
    var search_btn_link = "";
    var category_value = "all";

    $('.search-category-filter').click(function() {
        $('.sp-category-filter-box').show();
    });
    $('.box-close').click(function() {
        $('.sp-category-filter-box').hide();
    });

    $('.fliter-box-select').click(function() {
        $(this).toggleClass('active');
    });

    $('.box-tag-item').click(function() {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $('.box-tag-item').removeClass('active');
            $(this).addClass('active');
        }
        tag_value = $('.box-tag-item.active > span').html();
        if (tag_value != null) {
            $('.box-tag-select').html(tag_value);
            search_btn_link = "/collections/" + category_value + "/" + tag_value;
        } else {
            search_btn_link = "/collections/" + category_value;
        }
        $('.box-search-btn').attr('href', search_btn_link);
    });

    $('.box-category-item').click(function() {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $('.box-category-item').removeClass('active');
            $(this).addClass('active');
        }
        category_value = $('.box-category-item.active').attr('handle');
        if (category_value == null) {
            category_value = "all";
        }
        if (tag_value != null) {
            search_btn_link = "/collections/" + category_value + "/" + tag_value;
        } else {
            search_btn_link = "/collections/" + category_value;
        }
        $('.box-search-btn').attr('href', search_btn_link);
    });

    $('.c-category-link').each(function(){
        var ctgLink = $(this);
        if(ctgLink.hasClass('check_active'))
            ctgLink.on('click', function(e){
                e.preventDefault();
            });
        ctgLink.find('label span').on('click',function(){
            window.location.href = "/collections/all";
        })
    })
})

$(function() {
    $('.search-category-item').click(function() {
        $('.search-category-item').removeClass('active');
        $(this).addClass('active');
        $('.search-category-name').html($('.search-category-item.active > span').html());
        $('#search-category-name').val($('.search-category-item.active > span').html());
    });
    $('.search-tag-item').click(function() {
        $('.search-tag-item').removeClass('active');
        $(this).addClass('active');
        $('.search-tag-name').html($('.search-tag-item.active > span').html());
        $('#search-tag-name').val($('.search-tag-item.active > span').html());
    });
    onloadSearch();

    $('.search-container').submit(function(e){
        e.preventDefault();
        var term = $('#search-query').val();
        var ctg = $('#search-category-name').val();
        var tag = $('#search-tag-name').val();
        var new_url;

        if(ctg == "" || tag == "")
            new_url = "/collections/all/";
        else 
            new_url = "/collections/" + $('#search-category-name').val() + "/" +  $('#search-tag-name').val();
        if(term != "")
            new_url = new_url + "?q=" + term;

        window.location.href = new_url;
    });
})

function onloadSearch() {
    const urlParams = new URLSearchParams(window.location.search);
    const category = urlParams.get('category');
    const tag = urlParams.get('tag');
    if (category != null) {
        $('.search_result__category_name').html(category);
        $('.search_result__category_name').attr("href", '/collections/' + category);
        $('.search_product_item').css('display', 'none');
        $(`li[data-category='${category}']`).css('display', "block");
    } else {
        if (tag != null) {
            $('.search_product_item').css('display', 'none');
            $(`li[data-tag.includes('${tag}')]`).css('display', "block");
        } else {
            $('.search_product_item').css('display', 'block');
        }
    }
    if (tag != null) {
        $('.search_result__tag_name').html(tag);
        $('.search_result__tag_name').attr("href", '/collections/all/' + category);
    }
}